function scrollToForm(buttonId) {
  const button = document.getElementById(buttonId);
  if (button) {
    button.addEventListener('click', function () {
      const header = document.getElementById('header');
      const headerHeight = header ? header.offsetHeight : 0;
      const formBox = document.getElementById('logistic-form');
      const formBoxPosition = formBox.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: formBoxPosition - headerHeight,
        behavior: 'smooth',
      });
    });
  }
}

if (document.getElementById('form-scroll') || document.getElementById('form-scroll2')) {
  scrollToForm('form-scroll');
  scrollToForm('form-scroll2');
}
